import { render, staticRenderFns } from "./NoExisteEnServel.vue?vue&type=template&id=58bc6025&scoped=true"
import script from "./NoExisteEnServel.vue?vue&type=script&lang=js"
export * from "./NoExisteEnServel.vue?vue&type=script&lang=js"
import style0 from "./NoExisteEnServel.vue?vue&type=style&index=0&id=58bc6025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc6025",
  null
  
)

export default component.exports